export const styles = {
  container: 'tw-w-full tw-flex tw-items-center tw-gap-4 tw-mb-4',
  searchContainer: 'tw-w-[500px]',
  sortContainer: 'tw-flex tw-items-center tw-gap-2',
  sortLabel: 'tw-text-base tw-font-bold tw-text-neutral-600 tw-whitespace-nowrap',
  sortSelect: 'tw-min-w-[160px]',
  directionButton: `
    tw-p-2 tw-rounded-md tw-border tw-border-neutral-300 tw-bg-white
    tw-text-primary-500 tw-transition-colors
    hover:tw-bg-neutral-50 hover:tw-border-neutral-400
    disabled:tw-opacity-50 disabled:tw-cursor-not-allowed
  `,
  directionButtonActive: 'tw-bg-primary-50 tw-border-primary-300 tw-text-primary-600',
  clearButton: `
    tw-text-sm tw-text-neutral-500 tw-underline
    hover:tw-text-neutral-700 tw-transition-colors
  `,
};
